import { render, staticRenderFns } from "./ShiftEditForm.vue?vue&type=template&id=24404267"
import script from "./ShiftEditForm.vue?vue&type=script&lang=js"
export * from "./ShiftEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports